import colorScale from './leafletLegends';

export const popoverFormatter = (latlng, color, legend, legendValue, range) => {
  let rangeText = '';
  if (range) {
    if (range.min !== undefined && range.max !== undefined) {
      rangeText = `<span>(${range.min} - ${range.max}%)</span>`;
    } else if (range.min !== undefined) {
      rangeText = `<span>(Above ${range.min}%)</span>`;
    } else if (range.max !== undefined) {
      rangeText = `<span>(Below ${range.max}%)</span>`;
    }
  }
  return `
    <div>
        <div class='ms-1 me-4'> 
            <h6 class="text-700 fw-normal">
                <span>
                    Lat: ${latlng.lat.toFixed(3)} Lon: ${latlng.lng.toFixed(3)}
                </span>
            </h6>
        </div>
        <div class='ms-1'> 
            <h6 class="text-700 d-flex align-items-center">
                <i class='legend-bg' style="background-color:${color}"></i>
                <span>${legend}</span>${rangeText}
            </h6>
        </div>
    </div>
  `;
};

export const multiPopoverFormatter = (latlng, legends) => {
  let items = '';
  legends.forEach(obj => {
    if (obj.color) {
      items += `
        <h6 class="text-700 d-flex align-items-center">
          <span style="min-width:40px">${obj.varient}</span>
          <i class='legend-bg mb-1' style="background-color:${obj.color}"></i>
          <span>${obj.legend}</span>
        </h6>`;
    }
  });
  if (!items) {
    return '';
  }
  return `
    <div>
        <div class='ms-1 me-4'> 
            <h6 class="text-700 fw-normal">
                <span>
                    Lat: ${latlng.lat.toFixed(3)} Lon: ${latlng.lng.toFixed(3)}
                </span>
            </h6>
        </div>
        <div class='ms-1'> 
            ${items}
        </div>
    </div>
  `;
};

export const getColorScale = title => {
  if (title.includes('Tree Cover') && title.includes('vs')) {
    return colorScale['Tree Cover Comparison'];
  } else if (
    title.includes('Land Use') ||
    title.includes('Agricultural Drought') ||
    title.includes('Meteorological Drought') ||
    title.includes('Drought') ||
    title.includes('Vegetation') ||
    title.includes('Tree Cover') ||
    title.includes('Forest') ||
    title.includes('Water') ||
    title.includes('Water Stress') ||
    title.includes('Crop Acreage') ||
    title.includes('Soil Erosion') ||
    title.includes('Crop Health') ||
    title.includes('Crop Condition') ||
    title.includes('Crop Classification') ||
    title.includes('Water Contamination') ||
    title.includes('Soil Moisture Content') ||
    title.includes('Stubble')
  ) {
    return colorScale[Object.keys(colorScale).find(key => title.includes(key))];
  }
  const scale = colorScale[Object.keys(colorScale).find(key => title === key)];

  if (!scale && (title.includes('Soil') || title.includes('Oxygen'))) {
    return colorScale['Soil'];
  }

  return scale;
};

export const pixelValuesToColorFn = (value, title, legendData) => {
  const scale = legendData !== undefined ? legendData : getColorScale(title);

  if (value === -99) return null;

  // map the pixel value to the appropriate color
  const result = scale.find(item => {
    if (typeof item.pixelValue === 'number') {
      if (value === item.pixelValue) return item;
    } else if (typeof item.pixelValue === 'object') {
      const {
        min,
        max,
        minInclusive = false,
        maxInclusive = true
      } = item.pixelValue;
      if (min !== undefined && max !== undefined) {
        if (
          (minInclusive && value >= min && value <= max) ||
          (!minInclusive && value > min && value <= max) ||
          (!maxInclusive && value > min && value < max)
        ) {
          return item;
        } else return null;
      } else if (min !== undefined) {
        if ((minInclusive && value >= min) || (!minInclusive && value > min))
          return item;
      } else if (max !== undefined) {
        if ((maxInclusive && value <= max) || (!maxInclusive && value < max))
          return item;
      }
    }
  });

  return result ? result.bg_color : null;
};

export const legendTitle = {
  Vegetation: 'Vegetation Index',
  'Slope Direction': 'Slope Direction',
  Elevation: 'Elevation',
  Slope: 'Slope (in degree)',
  'Water Stress': 'Water Stress',
  'Fire Incidents': 'Frequency of fire',
  'Surface Water Extent': 'Surface Water Extent',
  'Mangrove Forest': 'Mangrove Forest',
  'Agriculture Drought': 'Agriculture Drought',
  'Meteorological Drought': 'Meteorological Drought',
  'Crop Acreage': 'Crop Acreage',
  'Soil Erosion': 'Soil Erosion',
  'Soil Moisture Content': 'Soil Moisture Content',
  'Water Contamination': 'Water Contamination'
};
